import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';

import React from 'react';
import classnames from 'classnames';

import { Button } from 'ui-components/components/button';
import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import style from './add-mfa-enrollment.module.less';

/**
 * @typedef {import('react-intl').MessageDescriptor} MessageDescriptor
 */

/**
 * @param {object} props
 * @param {React.JSX.Element} props.Icon
 * @param {boolean} props.isSelected
 * @param {MessageDescriptor} props.name
 * @param {() => void} props.onClick
 * @returns {React.JSX.Element}
 */
export const SelectEnrollmentButton = ({ Icon, isSelected, name, onClick }) => {
  return (
    <Button
      className={classnames(style['select-method-button'], {
        [style['selected-method']]: isSelected,
      })}
      onClick={onClick}
      theme='white-outlined'
    >
      <FlexRow className={style['select-method-button-content']}>
        <FlexRow gap={Gap.Space8}>
          <FlexColumn className={style['method-icon']}>{Icon}</FlexColumn>
          <Text textType={TextType.Paragraph} value={name} />
        </FlexRow>
        {isSelected ? (
          <FlexColumn className={style['selected-check-icon']}>
            <FontAwesomeIcon icon={faCheckCircle} />
          </FlexColumn>
        ) : null}
      </FlexRow>
    </Button>
  );
};
